/**
 * @generated SignedSource<<d122e751132a02b04c26e62035b7393c>>
 * @relayHash ab22500adcbda4ebc736f0b15ee0cae7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ab73338e0c38877c0aeb4877a60028344a275cba7400eea8b3055fa276098c9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation$variables = {
  ari: string;
  cloudId: string;
  type: ConfluenceTrackType;
};
export type ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation$data = {
  readonly confluence_removeTrack: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation = {
  response: ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation$data;
  variables: ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "mainSource",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "trackType",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceRemoveTrackPayload",
    "kind": "LinkedField",
    "name": "confluence_removeTrack",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceRemoveTrackPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          },
          {
            "concreteType": "ConfluenceRemoveTrackPayloadErrorExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "statusCode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "0ab73338e0c38877c0aeb4877a60028344a275cba7400eea8b3055fa276098c9",
    "metadata": {},
    "name": "ModifyPlaylistButtons_RemoveFromPlaylistButton_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "db6e061f0fecac804bd350e60b892e1d";

export default node;
